import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadContactTitles = async () => {
  try {
    const response = await Axios.get('titles');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};



export const loadContactTitle = async (action) => {
  try {
    switch (action) {
      case 'new':
        // const response = await Axios.get('setups/product-categories');
        // const responseData = await response.data;
        // return {...responseData, category: {}};
        return {};
        
      default:
        const respnse = await Axios.get('titles/'+action);
        const responseData = await respnse.data;
        return responseData;
    }
  }catch (err) {
    throw err;
  }
}

const useContactTitleAPI = () => {
  
  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('titles', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('title_created', data.seo);
    }catch(err) {
      throw err;
    }
  }

  const update = async (seo, data, success) => {
    try {
      const respnse = await Axios.put('tags/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('title_update', data.seo);
    }catch (err) {
      throw err;
    }
  }


  return { create, update };
};



export default useContactTitleAPI;


